import InvoiceItemTypeResource from "./invoiceItemType.resource";

const invoiceItemTypeModule = angular
  .module("app.resources.invoiceItemType", [])
  .service("InvoiceItemType", InvoiceItemTypeResource);

export default invoiceItemTypeModule;



// WEBPACK FOOTER //
// ./src/resources/invoiceItemType/invoiceItemType.module.js